import Component from "./DynamicFilter";
export default Component;
